export default __webpack_public_path__ + "static/media/Head_6_Ear_2_C1.4105ebf5.svg";